import React from "react";

const GetALoan = () => {
  const gotoApply = () => {
    window.open("https://app.checkoff.finance/", "_blank");
  };
  return (
    <div className="get-a-loan">
      <div>
        <h1>
          Get a loan in
          <br />
          less than 24 hours
        </h1>
        <button onClick={gotoApply} className="btn">
          Apply Now
        </button>
      </div>
    </div>
  );
};

export default GetALoan;
